export default class CalculatePriceDto {
    areaId:number;
    parkName: string;
    month: string;
    billsId: Array<any>;
    priceId: number;
    monthPrice: number;
    monthTotalUse: number;
    monthTotalAmmount: number;
    benchmarkPrice: number;
    floatingRange: number;
}